// 获取 预期可申报资助 数据
function getApplyFunding(value) {
  return {
    title: {
      text: '预期可申报资助',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: '12px'
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      x: 'left',
      y: '20px',
      data: ['五星', '四星', '三星']
    },
    series: [{
      type: 'pie',
      radius: ['50%', '70%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: 'top',
        emphasis: {
          show: true
        }
      },
      /*设置柱状图颜色*/
      itemStyle: {
        normal: {
          color: function (params) {
            let colors = ['rgb(84 112 198)', 'rgb(145 204 117)', 'rgb(250 200 88)']
            return colors[params.dataIndex]
          },
        }
      },
      labelLine: {
        show: true
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '30',
          fontWeight: 'bold'
        }
      },
      data: [{
          value: value.fiveStar,
          name: '五星'
        },
        {
          value: value.fourStar,
          name: '四星'
        },
        {
          value: value.thresStar,
          name: '三星'
        }
      ]
    }]
  }
}

// 获取 政策项目匹配度情况
function getProMatching(value) {
  return {
    title: {
      text: '政策项目匹配度情况',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: '12px'
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      x: 'left',
      y: '20px',
      data: ['五星', '四星', '三星']
    },
    series: [{
      type: 'pie',
      radius: ['50%', '70%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: 'top',
        emphasis: {
          show: true
        }
      },
      /*设置柱状图颜色*/
      itemStyle: {
        normal: {
          color: function (params) {
            let colors = ['rgb(84 112 198)', 'rgb(145 204 117)', 'rgb(250 200 88)']
            return colors[params.dataIndex]
          },
        }
      },
      labelLine: {
        show: true
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '30',
          fontWeight: 'bold'
        }
      },
      data: [{
          value: value.fiveStar,
          name: '五星'
        },
        {
          value: value.fourStar,
          name: '四星'
        },
        {
          value: value.threeStar,
          name: '三星'
        }
      ]
    }]
  }
}

// 获取 政策项目申报截至剩余时间
function getProLeftTime(value) {
  return {
    title: {
      text: '申报截至剩余时间',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: '12px'
      }
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      x: 'left',
      y: '20px',
      data: ['30天以上', '30天内', '15天内', '7天内', '3天内']
    },
    series: [{
      type: 'pie',
      radius: ['50%', '70%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: 'top',
        emphasis: {
          show: true
        }
      },
      /*设置柱状图颜色*/
      itemStyle: {
        normal: {
          color: function (params) {
            let colors = ['rgb(84 112 198)', 'rgb(145 204 117)', 'rgb(250 200 88)',
              'rgb(97 160 168)'
            ]
            return colors[params.dataIndex]
          },
        }
      },
      labelLine: {
        show: true
      },
      emphasis: {
        label: {
          show: true,
          fontSize: '30',
          fontWeight: 'bold'
        }
      },
      data: [{
          value: value.thirtyDayUp,
          name: '30天以上'
        },
        {
          value: value.thirtyDayDown,
          name: '30天内'
        },
        {
          value: value.fifteenDayDown,
          name: '15天内'
        },
        {
          value: value.sevenDayDown,
          name: '7天内'
        },
        {
          value: value.threedayDown,
          name: '3天内'
        }
      ]
    }]
  }
}

// 获取 受理部门分布
function getDeptAll(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['五星', '四星', '三星']
    },
    xAxis: [{
      type: 'category',
      data: value[0],
      axisLabel: {
        formatter: function (params) {
          var val = "";
          if (params.length > 8) {
            val = params.substr(0, 8) + '...';
            return val;
          } else {
            return params;
          }
        }
      },
    }],
    yAxis: [{
        type: 'value',
        name: '数量',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        },
      },
    ],
    series: [{
        name: '五星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(84 112 198)'
            },
          }
        },
        stack: '五星',
        data: value[3]
      },
      {
        name: '四星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(145 204 117)'
            },
          }
        },
        stack: '总量',
        data: value[5]
      },
      {
        name: '三星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
          }
        },
        data: value[7]
      },
      // {
      //   name:'金额',
      //   type:'line',
      //   yAxisIndex: 1,    //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
      //   data:value[2],
      //   symbolSize:10,
      //   itemStyle : {
      //       normal : {
      //           color: function (params) {
      //             return 'rgb(250 200 88)'
      //           },
      //           label : {
      //               show : true,
      //               position : 'top',
      //               textStyle : {
      //                   fontSize : '14',
      //                   color: 'rgb(255, 156, 54)',
      //               }
      //           }
      //       },
      //     },
      // },
    ]
  }
}
// 5、4、3星部门分布
function getDeptFiveStar(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['五星', ]
    },
    xAxis: [{
      type: 'category',
      data: value[0],
      axisLabel: {
        margin: 8,
        formatter: function (params) {
          var val = "";
          if (params.length > 8) {
            val = params.substr(0, 8) + '...';
            return val;
          } else {
            return params;
          }
        }
      },
    }],
    yAxis: [{
        type: 'value',
        name: '数量',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        },
      },
    ],
    series: [{
        name: '五星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(84 112 198)'
            },
          }
        },
        stack: '五星',
        data: value[3]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[4],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}

function getDeptFourStar(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['四星', ]
    },
    xAxis: [{
      type: 'category',
      data: value[0],
      axisLabel: {
        margin: 8,
        formatter: function (params) {
          var val = "";
          if (params.length > 8) {
            val = params.substr(0, 8) + '...';
            return val;
          } else {
            return params;
          }
        }
      },
    }],
    yAxis: [{
        type: 'value',
        name: '数量',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        },
      },
    ],
    series: [{
        name: '四星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(145 204 117)'
            },
          }
        },
        stack: '四星',
        data: value[5]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[6],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}

function getDeptThreeStar(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['三星', ]
    },
    xAxis: [{
      type: 'category',
      data: value[0],
      axisLabel: {
        margin: 8,
        formatter: function (params) {
          var val = "";
          if (params.length > 8) {
            val = params.substr(0, 8) + '...';
            return val;
          } else {
            return params;
          }
        }
      },
    }],
    yAxis: [{
        type: 'value',
        name: '数量',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        },
      },
    ],
    series: [{
        name: '三星',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
          }
        },
        stack: '三星',
        data: value[7]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[8],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}
// 获取 项目类别分布
function getProTypeAll(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['数量', '金额（万）']
    },
    xAxis: [{
      type: 'category',
      data: value[0]
    }],
    yAxis: [{
        type: 'value',
        name: '个数',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        }
      },
    ],
    series: [{
        name: '国家',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(84 112 198)'
            },
          }
        },
        data: value[3]
      },
      {
        name: '省级',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(145 204 117)'
            },
          }
        },
        data: value[5]
      },
      {
        name: '市级',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
          }
        },
        data: value[7]
      },
    ]
  }
}
// 国家
function getcountryProType(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['数量', '金额（万）']
    },
    xAxis: [{
      type: 'category',
      data: value[0]
    }],
    yAxis: [{
        type: 'value',
        name: '个数',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        }
      },
    ],
    series: [{
        name: '国家',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(84 112 198)'
            },
          }
        },
        data: value[3]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[4],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}
// 省级
function getProvincialProType(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['数量', '金额（万）']
    },
    xAxis: [{
      type: 'category',
      data: value[0]
    }],
    yAxis: [{
        type: 'value',
        name: '个数',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        }
      },
    ],
    series: [
      {
        name: '省级',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(145 204 117)'
            },
          }
        },
        data: value[5]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[6],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}
// 市级
function getcityProType(value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['数量', '金额（万）']
    },
    xAxis: [{
      type: 'category',
      data: value[0]
    }],
    yAxis: [{
        type: 'value',
        name: '个数',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '金额',
        axisLine: {
          show: true,
          lineStyle: {
            // color: colors[1]
          }
        },
        axisLabel: {
          formatter: '{value} 万'
        }
      },
    ],
    series: [
      {
        name: '市级',
        type: 'bar',
        /*设置柱状图颜色*/
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
          }
        },
        data: value[7]
      },
      {
        name: '金额',
        type: 'line',
        yAxisIndex: 1, //这里要设置哪个y轴，默认是最左边的是0，然后1，2顺序来。
        data: value[8],
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: function (params) {
              return 'rgb(250 200 88)'
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                fontSize: '14',
                color: 'rgb(255, 156, 54)',
              }
            }
          },
        },
      },
    ]
  }
}
// 获取 企业近三年经营情况分析
function getFinanceThreeYear(year, value) {
  return {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: [year[0], year[1], year[2]]
    },
    xAxis: {
      type: 'category',
      data: ['总资产', '净利润', '营业收入', '主营业务收入', '资产投入', '负债总额', '税收总额', '研发投入']
    },
    yAxis: {
      name: '金额',
      type: 'value',
      axisLine: {
        show: true,
        lineStyle: {
          // color: colors[1]
        }
      },
      axisLabel: {
        formatter: '{value} 万'
      }
    },
    series: [{
        name: year[0],
        data: [value[0][0], value[0][1], value[0][2], value[0][3], value[0][4], value[0][5],
          value[0][6], value[0][7]
        ],
        type: 'line',
        stack: 'x'
      },
      {
        name: year[1],
        data: [value[1][0], value[1][1], value[1][2], value[1][3], value[1][4], value[1][5],
          value[1][6], value[1][7]
        ],
        type: 'line',
        stack: 'x'
      },
      {
        name: year[2],
        data: [value[2][0], value[2][1], value[2][2], value[2][3], value[2][4], value[2][5],
          value[2][6], value[2][7]
        ],
        type: 'line',
        stack: 'x'
      }
    ]
  };
}

function getIntellectualProperty(name, sname, value, index) {
  return {
    title: {
      text: name + '占比',
      left: 'center',
      top: 'center',
      textStyle: {
        fontSize: '12px'
      }
    },
    series: [{
      type: 'pie',
      itemStyle: {
        normal: {
          color: function (params) {
            let colorOne = ['rgb(186,85,211)', 'rgb(255,99,71)', 'rgb(250 200 88)']
            let colorTwo = ['rgb(50,205,50)', 'rgb(220,20,60)', 'rgb(250 200 88)']
            let colorThree = ['rgb(0,206,209)', 'rgb(139,0,139)', 'rgb(250 200 88)']
            let colorFour = ['rgb(255,165,0)', 'rgb(0,0,255)', 'rgb(250 200 88)']
            switch (index) {
              case 1:
                return colorOne[params.dataIndex];
                break;
              case 2:
                return colorTwo[params.dataIndex];
                break;
              case 3:
                return colorThree[params.dataIndex];
                break;
              case 4:
                return colorFour[params.dataIndex];
                break;
            }

            // return colors[params.dataIndex]
          },
        }
      },
      data: [{
          value: value[0],
          name: name
        },
        {
          value: value[1],
          name: sname
        }
      ],
      radius: ['40%', '70%']
    }]
  }
}

module.exports = {
  getApplyFunding,
  getProMatching,
  getProLeftTime,
  getDeptAll,
  getDeptFiveStar,
  getProTypeAll,
  getFinanceThreeYear,
  getIntellectualProperty,
  getDeptFourStar,
  getDeptThreeStar,
  getcountryProType,
  getProvincialProType,
  getcityProType
}
